import type { UserStore } from '@acme/domains';
import { UserStoreProvider, useUser } from '@acme/domains';
import React, { useEffect, useState } from 'react';

interface AuthProviderProps {
  children: React.ReactNode;
  store: UserStore;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({
  children,
  store,
}) => {
  return (
    <UserStoreProvider store={store}>
      <AuthProviderInner>{children}</AuthProviderInner>
    </UserStoreProvider>
  );
};

interface AuthProviderInnerProps {
  children: React.ReactNode;
}

const AuthProviderInner: React.FC<AuthProviderInnerProps> = ({ children }) => {
  const { setToken, tokenInstaled, getAuth, fetch, isLoading } = useUser();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!tokenInstaled) {
      setToken();
      if (getAuth()) {
        fetch();
      }
    }
  }, [tokenInstaled, setToken, getAuth, fetch]);

  useEffect(() => {
    if (tokenInstaled && (!getAuth() || !isLoading)) {
      setIsInitialized(true);
    }
  }, [tokenInstaled, isLoading, getAuth]);

  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Инициализация...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
